import React, { Component } from 'react';
import { ReactTags } from 'react-tag-autocomplete';

import '../components/TagAutocomplete.scss';

export default class TagAutocomplete extends Component {
    handleAdd = (tag) => {
        const tags = [ ...this.props.value, tag ];
        this.props.onChange({ target: { value: tags }});
    }

    handleDelete = (idx) => {
        const tags = this.props.value.filter((v, i) => i !== idx);
        this.props.onChange({ target: { value: tags }});
    }

    render() {
        return <ReactTags selected={this.props.value} suggestions={this.props.options} allowNew={true} onAdd={this.handleAdd} onDelete={this.handleDelete} />;
    }
}